// Module
var code = "<h3 id=\"glossary\">Glossary</h3> <p><a href=\"index.md\">Back to index</a></p> ";
// Exports
export default code;